import React from 'react';
// Data
import {
  contactPageAdditionalMeta,
  contactPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ContactPageMainContainer from '../../components/contact/ContactPageMainContainer';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';
import FooterComponent from '../../components/footer/FooterComponent';

function ContactPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Contact'
        desc='Contact Mistress Maria to book a session, ask a question, or begin your journey into discipline and devotion. Serious inquiries only.'
        keywords='Mistress Maria, contact Mistress, book a session, domination, BDSM, discipline, UK Domme, submissive training, kink appointments'
        additionalMeta={contactPageAdditionalMeta}
        structuredData={contactPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'How To Contact Me'} />
          </header>
        </div>

        {/* Main page content */}
        <ContactPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default ContactPage;
